export default process.env.APP_ENV === 'test'
